import { Injectable } from "@angular/core";
import { SignalRService } from "./core/signalr.service";
import { FeatureService } from "./core/feature.service";
import { FeatureHelper } from "./core/static-classes/feature-helper";

@Injectable()
export class AppShellSignalRStore {

    constructor(
        private readonly signalRService: SignalRService,
        private readonly featureService: FeatureService,
    ) {}

    public init(user: PlantDesign.UI.IUser, isPopOut: boolean): void {
        if (!this.isFeatureEnabled()) {
            return;
        }
        if (user && !isPopOut) {
            this.initSignalR();
        } else if (!user) {
            this.stopSignalRConnection();
        }
    }

    private isFeatureEnabled(): boolean {
        return this.featureService.hasToggleFeature(FeatureHelper.flags.enableSignalRNotifications);
    }

    private initSignalR(): void {
        if (!this.signalRService.isConnected()) {
            this.initializeSignalR();
        }
    }

    private async initializeSignalR(): Promise<void> {
        try {
            await this.signalRService.startConnection();
        } catch (error) {
            console.error('Failed to initialize SignalR:', error);
        }
    }

    public stopSignalRConnection(): void {
        if (!this.signalRService.isConnected()) {
            return;
        }
        this.signalRService.stopConnection().catch(error => {
            console.error('Error stopping SignalR connection:', error);
        });
    }

}
